import React from 'react';
import { useHistory } from 'react-router-dom';

// This used to render nothing but a spinner and call history.goBack() on mount.
// When the destination that bounced you here is itself reachable again (an
// unmounted route the app keeps redirecting to, a role gate that sends you
// back), goBack lands on a page that immediately navigates here again — an
// invisible loop that looks like a white screen with a flickering loader, with
// no console trace because production stubs out console.log (see index.js).
// So: show a real 404 and let the user choose where to go.
const NotFound = () => {
  const history = useHistory();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        height: '100vh',
        textAlign: 'center',
        padding: '24px',
      }}
    >
      <h1 style={{ fontSize: '48px', margin: 0, color: '#044DB5' }}>404</h1>
      <p style={{ margin: 0, fontSize: '18px' }}>
        This page doesn&apos;t exist or isn&apos;t available for your account.
      </p>
      <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
        <button
          type="button"
          onClick={() => history.goBack()}
          style={{
            padding: '10px 20px',
            borderRadius: '6px',
            border: '1px solid #044DB5',
            background: 'transparent',
            color: '#044DB5',
            cursor: 'pointer',
          }}
        >
          Go back
        </button>
        <button
          type="button"
          onClick={() => history.push('/')}
          style={{
            padding: '10px 20px',
            borderRadius: '6px',
            border: '1px solid #044DB5',
            background: '#044DB5',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Go home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
